import { render, staticRenderFns } from "./NoobMenu.vue?vue&type=template&id=5e31539f&"
import script from "./NoobMenu.vue?vue&type=script&lang=js&"
export * from "./NoobMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports